import { useTheme } from "arkh";
import { UserLoggedInNavigatorScreenProps } from "../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { HeaderButton } from "../../../components";
import { RoutineOccasionScreen } from "./RoutineOccasionScreen";
import { RoutineOccasionStack } from "./RoutineOccasionStack";
import { BottomSheetModalProvider } from "@gorhom/bottom-sheet";
import { Platform } from "react-native";
import React, { useCallback } from "react";
import { PortalHost } from "@gorhom/portal";
import { TodoBottomSheetProvider } from "../../ReportIssueBottomSheet/TodoBottomSheet/TodoBottomSheetProvider";
import { AbsolutePopoverHostName } from "../../../components/mobile/AbsolutePopover";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import { StoreBanner } from "../../../components/OrgHeaders/StoreBanner";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useSizeClass } from "../../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";
import { StatusBar } from "expo-status-bar";
import { TimeZoneProvider } from "../../../OS/Timezone";

export const RoutineOccasionNavigator = withWebModal(
  RoutineOccasionNavigatorC,
  true,
  {
    width: 850,
    height: 960,
  }
);
function RoutineOccasionNavigatorC(
  props: UserLoggedInNavigatorScreenProps<"RoutineOccasion">
) {
  const theme = useTheme();
  const { setOptions } = props.navigation;
  const onBottomSheetOpen = useCallback(
    () => setOptions({ gestureEnabled: false }),
    [setOptions]
  );
  const onBottomSheetClosed = useCallback(() => {
    setOptions({ gestureEnabled: true });
  }, [setOptions]);
  const insets = useSafeAreaInsets();
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  return (
    <TimeZoneProvider timezone={props.route.params.storeTimezone}>
      <BottomSheetModalProvider>
        <TodoBottomSheetProvider
          openProductDetail={(productId) =>
            props.navigation.navigateDeprecated("Product", {
              screen: "ProductMain",
              params: {
                id: productId,
                type: "id",
                state: "details",
              },
            })
          }
          onShowFile={(id) =>
            props.navigation.navigateDeprecated("File", { id })
          }
          onBottomSheetOpen={onBottomSheetOpen}
          onBottomSheetClosed={onBottomSheetClosed}
          openTodoEditCategory={(todoId) => {
            props.navigation.navigateDeprecated("TodoMoveToCategory", {
              todoId,
            });
          }}
        >
          {props.route.params.storeName ? (
            <>
              {Platform.OS === "ios" && !isCompact ? (
                <StatusBar style="light" />
              ) : null}
              <StoreBanner
                storeName={props.route.params.storeName}
                insetTop={Platform.OS === "ios" && !isCompact ? insets.top : 0}
              />
            </>
          ) : null}

          <RoutineOccasionStack.Navigator
            screenOptions={{
              ...(Platform.OS === "android" ? { statusBarStyle: "dark" } : {}),
            }}
          >
            <RoutineOccasionStack.Screen
              name="RoutineOccasionMain"
              component={RoutineOccasionScreen}
              initialParams={props.route.params}
              options={{
                headerLeft:
                  Platform.OS === "ios" || Platform.OS === "web"
                    ? () => (
                        <HeaderButton
                          type="DONE"
                          onPress={props.navigation.goBack}
                        />
                      )
                    : undefined,
                headerShown: true,
                headerBackTitle: "",
                headerShadowVisible: false,
                title: "",
                headerTitleAlign: "center",

                headerStyle: {
                  backgroundColor: theme.surface,
                },
              }}
            />
          </RoutineOccasionStack.Navigator>
        </TodoBottomSheetProvider>
        <PortalHost name="RoutineOccasionHistoryProvider" />
        <PortalHost name={AbsolutePopoverHostName} />
      </BottomSheetModalProvider>
    </TimeZoneProvider>
  );
}
